// extracted by mini-css-extract-plugin
export default {"modal":"largeStyles_modal__TEh0g","modalContent":"largeStyles_modalContent__XnBpk","formGrid":"largeStyles_formGrid__OIuEG","buttonContainer":"largeStyles_buttonContainer__yrcPx"};